import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("li", { class: "complete" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("li", { class: "active" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = ["value", "max"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "集計が完了しました", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "対象のフォルダに指定のテンプレートがありませんでした。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("canvas", { id: "chart" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressStep = _resolveComponent("ProgressStep")!
  const _component_ModalMsg = _resolveComponent("ModalMsg")!
  const _component_Button = _resolveComponent("Button")!
  const _component_tereport = _resolveComponent("tereport")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_openBlock(), _createBlock(_component_AppContent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_ProgressStep, null, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.status == 'running')
          ? (_openBlock(), _createBlock(_component_ModalMsg, {
              key: 0,
              title: "集計中..."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.progressState.msg), 1),
                _createElementVNode("progress", {
                  value: _ctx.progressState.now,
                  max: _ctx.progressState.max
                }, _toDisplayString(_ctx.progressState.now) + "/" + _toDisplayString(_ctx.progressState.max), 9, _hoisted_4)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.status == 'success')
          ? (_openBlock(), _createBlock(_component_ModalMsg, {
              key: 0,
              title: "完了"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _ctx.openResult,
                    type: "fill"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("集計結果")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.status == 'failure')
          ? (_openBlock(), _createBlock(_component_ModalMsg, {
              key: 0,
              title: "完了"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.status = 'nothing')),
                    type: "line"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("とじる")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])),
      _createVNode(_component_tereport, { to: "body" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}